import { IndividualRepetitionDrawer } from '@/domain/termine/features/UpdateTermin/Mobile/components/IndividualRepetitionDrawer';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import {
  TerminWiederholung,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import { getFixedWeekday } from '@/domain/termine/shared/utils/getWeekdaySelection';
import { IndividuellerWiederholungsText } from '@/domain/termine/shared/utils/IndividuellerWiederholungsText';
import { cn } from '@/lib/utils';
import { Button } from '@e2n/ui';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useState } from 'react';

export function IndividualRepetitionButton({ form }: UpdateTermineFormProps) {
  const [open, setOpen] = useState(false);

  return (
    <form.Subscribe selector={(state) => state.values}>
      {(values) => {
        const individuelleWiederholung =
          values.wiederholung === TerminWiederholung.INDIVIDUELL;

        return (
          individuelleWiederholung && (
            <>
              <Button
                variant="subtle"
                className={cn(
                  'justify-between items-center bg-neutrals-200 text-xs text-neutrals-800 cursor-pointer md:hidden font-normal min-h-14',
                )}
                onClick={(e) => {
                  setOpen(true);
                  e.preventDefault();
                  e.stopPropagation();
                }}>
                <IndividuellerWiederholungsText
                  wiederholung={{
                    occurrenceCount: values.occurrenceCount ?? 1,
                    weekDayOccurrence: values.wochentagAuftreten,
                    wiederholungsIntervall:
                      values.wiederholungsIntervall ??
                      TerminWiederholungsIntervall.WOCHE,
                    wochentage: values.wochentagAuswahl
                      ? values.wochentagAuswahl
                      : [getFixedWeekday(dayjs(values.datum))],
                  }}
                  wiederholungBis={values.wiederholungBis}
                  datum={values.datum}
                />
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="text-neutrals-700"
                />
              </Button>
              <IndividualRepetitionDrawer
                open={open}
                onOpenChange={setOpen}
                form={form}
              />
            </>
          )
        );
      }}
    </form.Subscribe>
  );
}
